<a *ngIf="protestParent.children_Protest_InfoList.length > 0"
   id="{{protestParent.b_No}}" (click)="expandAndCollapse()"
   aria-label="Open/Close list of consolidated cases, defaults open.">
  <mat-icon aria-hidden="false" aria-label="expand_less" *ngIf="isDisplayed">expand_less</mat-icon>
  <mat-icon aria-hidden="false" aria-label="expand_more" *ngIf="!isDisplayed">expand_more</mat-icon>
</a>
<a href="javascript:void(0)" *ngIf="!disableCaseDocketParent" title="{{protestParent.b_No || 'Pending'}} / {{protestParent.a_No}}"
   (click)="redirectToCaseDocket(protestParent)">
  {{protestParent.b_No || 'Pending'}}
</a>
<span *ngIf="disableCaseDocketParent" title="{{protestParent.b_No || 'Pending'}} / {{protestParent.a_No}}">{{protestParent.b_No || 'Pending'}}</span>
<span title='{{protestParent.supplemental_A_Nos}}'> {{protestParent.supplemental_B_Nos}} </span>
<ul *ngFor="let childProtestInfo of protestParent.children_Protest_InfoList"
    id="supplemental-protest-list_{{protestParent.b_No}}" [hidden]="!isDisplayed">
  <li>
    <a title='{{childProtestInfo.company_Name}}, {{childProtestInfo.b_No}}, {{childProtestInfo.a_No}}' href="javascript:void(0)" *ngIf='!disableCaseDocketParent'
       (click)='redirectToCaseDocket(childProtestInfo)'>
      {{childProtestInfo.company_Name | truncate}},&nbsp;{{childProtestInfo.b_No | truncate:10}}
    </a>
    <span *ngIf='disableCaseDocketParent' title="{{childProtestInfo.company_Name}}, {{childProtestInfo.b_No}}, {{childProtestInfo.a_No}}">
      {{childProtestInfo.company_Name | truncate}},&nbsp;{{childProtestInfo.b_No}}
    </span>
    <span title='{{childProtestInfo.supplemental_A_Nos}}'>{{childProtestInfo.supplemental_B_Nos}}</span>
  </li>
</ul>
